import { valueMapper } from "./valueMapper";
import { heightMapper, weightMapper } from "./measurementMapper";
import { medicationGridMapper } from "./medicationMapper";
import { conditionGridMapper } from "./conditionGridMapper";
import { aiMedicationMapper } from "./aiMedicationMapper";
import { multiSelectMapper } from "./multiSelectMapper";

export const mappers = {
  value: valueMapper,
  height: heightMapper,
  weight: weightMapper,
  medicationGrid: medicationGridMapper,
  conditionGrid: conditionGridMapper,
  aiMedication: aiMedicationMapper,
  multiSelect: multiSelectMapper,
}; 